import { Effect, Layer } from "effect";
import { BrowserHttpClient } from "@effect/platform-browser";
import { friendlyStationId, stationHostname, withWorkerstationBase } from "@workerstation/shared";
import { recordStationVisit, readRecentStations, forgetStation } from "../recent-stations.ts";
import { makeChatApi } from "../api/chat/live.ts";
import { ChatApi } from "../api/chat/service.ts";
import { LauncherBrowserIo } from "./view-service.ts";
import { ChatBrowserIoLive } from "./live.ts";
import { ChatFileIoLive } from "./file-live.ts";
const api = Layer.effect(ChatApi, Effect.gen(function* () {
  const base = yield* Effect.sync(() => (typeof window === "undefined" ? "https://workerstation.invalid" : window.location.origin) + withWorkerstationBase(""));
  return yield* makeChatApi(base);
})).pipe(Layer.provide(BrowserHttpClient.layerFetch));
export const LauncherBrowserIoLive = Layer.succeed(LauncherBrowserIo, LauncherBrowserIo.of({
  recent: Effect.sync(readRecentStations), forget: id => Effect.sync(() => forgetStation(id)),
  create: Effect.sync(() => friendlyStationId([Math.random(), Math.random(), Math.random()])),
  open: (stationId, threadId) => Effect.sync(() => {
    recordStationVisit(stationId); const query = threadId ? `?thread=${encodeURIComponent(threadId)}` : "";
    window.location.assign(`${window.location.protocol}//${stationHostname(stationId)}/${query}`);
  })
}));
export const ChatBrowserPortsLive = Layer.mergeAll(api, ChatBrowserIoLive, ChatFileIoLive, LauncherBrowserIoLive);
